export default "__VITE_ASSET__BxTNq$38__"